const DEVICE_LOCAL_SCHEME = /^(?:file|content|blob|ph|assets-library):/i;
const WINDOWS_ABSOLUTE_PATH = /^[a-z]:[\\/]/i;

export const isDeviceLocalProfileImage = (value) => {
    if (typeof value !== 'string') return false;
    const normalized = value.trim();
    return normalized.startsWith('/') || normalized.startsWith('\\') || WINDOWS_ABSOLUTE_PATH.test(normalized) || DEVICE_LOCAL_SCHEME.test(normalized);
};

const sameProfileList = (left, right) => {
    if (!Array.isArray(left) || !Array.isArray(right) || left.length !== right.length) return false;
    return left.every((value, index) => value === right[index]);
};

export const buildProfileImageUpdate = (original = [], current = []) => {
    if (sameProfileList(original, current)) return {};
    if (!Array.isArray(current) || current.some((value) => typeof value !== 'string' || value.trim() !== value || value.length === 0 || isDeviceLocalProfileImage(value))) {
        throw new Error('표시할 수 없는 사진은 고객 재등록 후 수정할 수 있습니다.');
    }
    return { image_list: current };
};
